module.exports = __webpack_public_path__ + "static/media/58.8af88271.png";